import { render } from "./orders_by_products.vue?vue&type=template&id=4aaf9d05&scoped=true"
import script from "./orders_by_products.vue?vue&type=script&lang=js"
export * from "./orders_by_products.vue?vue&type=script&lang=js"

import "./orders_by_products.vue?vue&type=style&index=0&id=4aaf9d05&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aaf9d05"]])

export default __exports__